import { environmentHttpClient } from "client/Api/httpClient";
import { HubItemKind } from "./hubItemCategories";
import { ListLocationModel, ListLocationViewModel } from "../Documents/SharePoint/common";

export type HubCommunitiesManagementViewModel = {
	isEnabled: boolean;
	canManageSettings: boolean;
	canManageCommunities: boolean;
	canManageMembershipRequests: boolean;
};

export type HubItemManagementViewModel = {
	manageableKinds: readonly HubItemKind[];
	canManageTemplates: boolean;
};

export enum DocumentLocationModelKind {
	SharePoint = 1,
	WebDav = 2
}

type BaseDocumentLocationViewModel = {
	displayName: string;
};

export type SharePointDocumentLocationViewModel = BaseDocumentLocationViewModel & {
	kind: DocumentLocationModelKind.SharePoint;
	itemId: number | null;
	listLocation: ListLocationViewModel;
};

export type WebDavDocumentLocationViewModel = BaseDocumentLocationViewModel & {
	kind: DocumentLocationModelKind.WebDav;
	serverId: number;
	fileId: string;
};

export type DocumentLocationViewModel =
	| SharePointDocumentLocationViewModel
	| WebDavDocumentLocationViewModel;

export type SharePointDocumentLocationSaveModel = {
	kind: DocumentLocationModelKind.SharePoint;
	itemId: number | null;
	listLocation: ListLocationModel;
};

export type WebDavDocumentLocationSaveModel = {
	kind: DocumentLocationModelKind.WebDav;
	serverId: number;
	fileId: string;
};

export type DocumentLocationSaveModel =
	| SharePointDocumentLocationSaveModel
	| WebDavDocumentLocationSaveModel;

export type HubManagementSettingsViewModel = {
	defaultImageLocation: DocumentLocationViewModel | null;
};

export type HubManagementViewModel = {
	hubItems: HubItemManagementViewModel;
	communities: HubCommunitiesManagementViewModel;
	canManageSettings: boolean;
};

export type HubManagementSettingsSaveModel = {
	defaultImageLocation: OptionalModel<DocumentLocationSaveModel | null>;
};

export function getHubManagement(
	signal?: AbortSignal
): Promise<HubManagementViewModel> {
	return environmentHttpClient.get<HubManagementViewModel>(
		"/UiApi/HubSettings",
		undefined,
		{ signal }
	);
}

export function getHubSettings(
	signal?: AbortSignal
): Promise<HubManagementSettingsViewModel> {
	return environmentHttpClient.get<HubManagementSettingsViewModel>(
		"/UiApi/HubSettings/Settings",
		undefined,
		{ signal }
	);
}

export function saveHubSettings(
	model: HubManagementSettingsSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		"/UiApi/HubSettings/Settings",
		model,
		{ signal }
	);
}